export enum Role {
  User = 'User'
}
